module.exports = __webpack_public_path__ + "static/media/sound-on.09f72cb5.png";